import React from 'react';
// template components
import StatModule from '@nmx/template/dist/componentLibrary/modules/StatModule';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import NerdWalletLogo from './images/nerdwallet-light-usage.svg';
// styles
import { PictureStyled } from './styles';

export default () => (
  <StatModule
    sectionId='whole-life-insurance-intro'
    headingText={<>What is whole <WidowBlock>life insurance&#63;</WidowBlock></>}
    descriptionText={(
      <>
        Enjoy lifelong protection<sup>1</sup> and other features you can use throughout your life with this type of permanent life insurance. As you make payments, your policy will accumulate cash value. It&#39;s guaranteed to grow (typically tax&#45;deferred) regardless of market ups and downs. You can use the cash value for whatever you want or need.<sup>2</sup> You can also earn dividends<sup>3</sup> that can be taken as cash, used to pay premiums, or buy more coverage.
      </>
    )}
    moduleName='stat-module'
    moduleVariation='A'
    ctaPrimary={{
      linkUrl: '/find-a-financial-advisor/',
      linkText: 'Get started',
      ariaLabel: 'Learn how to protect your assets with a financial advisor',
      linkId: 'whole-life-insurance-product-intro-cta-button',
      children: '',
    }}
    ctaSecondary={{
      linkUrl: '',
      children: '',
    }}
    cardHeadingText='No. 1'
    cardHeadingTextAriaLabel='Number one'
    cardDescriptionText={(
      <>
        Best life insurance company for consumer experience<sup>4</sup>
        <PictureStyled
          src={NerdWalletLogo}
          altText='NerdWallet logo'
        />
      </>
    )}
  />
);
